import { ActivityIndicator } from '@chillibean/component-library/legacy';

function ReportingSpinner() {
  return (
    <div className="reporting__activity-indicator-wrapper">
      <ActivityIndicator />
    </div>
  );
}

export default ReportingSpinner;
